import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

export const useIsJoinStep = () => {
    const { registrationNameStep } = useRegistrationSelector();

    return registrationNameStep === STEP_NAMES.JOIN_STEP || registrationNameStep === STEP_NAMES.MEMBERSHIP_STEP;
};
